import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

import HitWithWishlist from './HitWithWishlist';
import PerfectFitProduct from '../../components/result/PerfectFitProduct';

export default function PerfectFitHit({ results, hit, additionalData }: componentTypes.HitProps) {
  return (
    <HitWithWishlist
      results={results}
      hit={hit}
      additionalData={additionalData}
      component={PerfectFitProduct}
    />
  );
}
